import { Routes } from '@angular/router';
import { LoginRouteGuardService } from './services/_core/login-route-guard/login-route-guard.service';
import { DeviceRouteGuardService } from './services/_core/device-route-guard/device-route-guard.service';
import { ActivityTimerRouteGuardService } from './services/_core/activity-timer-route-guard/activity-timer-route-guard.service';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/tabs/tabs.routes').then((m) => m.routes),
  },
  {
    path: 'login',
    pathMatch: 'full',
    canActivate: [ActivityTimerRouteGuardService],
    loadComponent: () => import('./pages/login/login.page').then( m => m.LoginPage)
  },
  {
    path: 'help',
    canActivate: [DeviceRouteGuardService],
    loadComponent: () => import('./pages/_core/help/help.page').then( m => m.HelpPage)
  },
  {
    path: 'share',
    canActivate: [DeviceRouteGuardService],
    loadComponent: () => import('./pages/_core/share/share.page').then( m => m.SharePage)
  },
  {
    path: 'check-for-updates',
    canActivate: [DeviceRouteGuardService],
    loadComponent: () => import('./pages/_core/check-for-updates/check-for-updates.page').then( m => m.CheckForUpdatesPage)
  },
  {
    path: 'help-forgot-pwd',
    canActivate: [DeviceRouteGuardService],
    loadComponent: () => import('./pages/_core/help-forgot-pwd/help-forgot-pwd.page').then( m => m.HelpForgotPwdPage)
  },
  {
    path: 'feedback-modal',
    canActivate: [DeviceRouteGuardService],
    loadComponent: () => import('./pages/_core/feedback-modal/feedback-modal.page').then( m => m.FeedbackModalPage)
  },
  {
    path: 'cases-view',
    canActivate: [DeviceRouteGuardService],
    loadComponent: () => import('./pages/cases-view/cases-view.page').then( m => m.CasesViewPage)
  },
  {
    path: 'my-account',
    canActivate: [LoginRouteGuardService, DeviceRouteGuardService],
    loadComponent: () => import('./pages/_core/my-account/my-account.page').then( m => m.MyAccountPage)
  },
  {
    path: 'language-modal',
    canActivate: [DeviceRouteGuardService],
    loadComponent: () => import('./pages/_core/language-modal/language-modal.page').then( m => m.LanguageModalPage)
  },
  {
    path: 'language-popover',
    canActivate: [DeviceRouteGuardService],
    loadComponent: () => import('./pages/_core/language-popover/language-popover.page').then( m => m.LanguagePopoverPage)
  },
  {
    path: 'language-translator',
    canActivate: [DeviceRouteGuardService],
    loadComponent: () => import('./pages/_core/language-translator/language-translator.page').then( m => m.LanguageTranslatorPage)
  },
  {
    path: 'survey-list',
    canActivate: [DeviceRouteGuardService],
    loadComponent: () => import('./pages/survey-list/survey-list.page').then( m => m.SurveyListPage)
  },
  {
    path: 'survey-view',
    canActivate: [DeviceRouteGuardService],
    loadComponent: () => import('./pages/survey-view/survey-view.page').then( m => m.SurveyViewPage)
  },
  {
    path: 'manage-survey',
    canActivate: [DeviceRouteGuardService],
    loadComponent: () => import('./pages/manage-survey/manage-survey.page').then( m => m.ManageSurveyPage)
  },
  {
    path: 'survey-langauge-pick',
    canActivate: [ActivityTimerRouteGuardService],
    loadComponent: () => import('./pages/survey-langauge-pick/survey-langauge-pick.page').then( m => m.SurveyLangaugePickPage)
  },
  {
    path: 'survey-questionnaire',
    canActivate: [ActivityTimerRouteGuardService],
    loadComponent: () => import('./pages/survey-questionnaire/survey-questionnaire.page').then( m => m.SurveyQuestionnairePage)
  },
  {
    path: 'review-survey-submissions',
    canActivate: [DeviceRouteGuardService],
    loadComponent: () => import('./pages/review-survey-submissions/review-survey-submissions.page').then( m => m.ReviewSurveySubmissionsPage)
  },
  {
    path: 'redirect',
    canActivate: [ActivityTimerRouteGuardService],
    loadComponent: () => import('./pages/redirect/redirect.page').then( m => m.RedirectPage)
  },
  {
    path: 'manage/users',
    canActivate: [LoginRouteGuardService, DeviceRouteGuardService],
    data: { pageName: 'Patient View', roles: ['sys_admin', 'admin'] },
    loadComponent: () => import('./pages/manage-users/manage-users.page').then( m => m.ManageUsersPage)
  },
  {
    path: 'manage/locations',
    canActivate: [LoginRouteGuardService, DeviceRouteGuardService],
    data: { pageName: 'Patient View', roles: ['sys_admin', 'admin'] },
    loadComponent: () => import('./pages/manage-locations/manage-locations.page').then( m => m.ManageLocationsPage)
  },
  {
    path: 'survey-selection',
    canActivate: [ActivityTimerRouteGuardService],
    loadComponent: () => import('./pages/survey-selection/survey-selection.page').then( m => m.SurveySelectionPage)
  },
  {
    path: 'manage-surveys',
    canActivate: [DeviceRouteGuardService],
    loadComponent: () => import('./pages/manage-surveys/manage-surveys.page').then( m => m.ManageSurveysPage)
  },
];
